
export const supportLocation = "/support";
